import React from "react";
import PropTypes from "prop-types";
import { Container, Row, Col } from "shards-react";

const DefaultLogin = ({ children, noNavbar, noFooter }) => (
  <Container fluid>
    <Row>
     <Col md="7">
     <div className="bg"></div>

     </Col>
      <Col md="5"
        className="main-content"
        tag="main"
      >
        
        {children}
      
      </Col>
    </Row>
  </Container>
);

DefaultLogin.propTypes = {
  /**
   * Whether to display the navbar, or not.
   */
  noNavbar: PropTypes.bool,
  /**
   * Whether to display the footer, or not.
   */
  noFooter: PropTypes.bool
};

DefaultLogin.defaultProps = {

};

export default DefaultLogin;
